<ion-content>
  <ion-grid class="ion-no-padding" style="height: 90%">
    <ion-row
      class="ion-no-padding ion-no-margin ion-justify-content-center ion-align-items-center"
      style="height: 100%; flex-direction: column"
    >
      <div style="width: 95%">
        <ion-card class="ion-margin-bottom no-shadow ion-text-center bg-trans">
          <img
            [src]="'assets/images/BookingDone.gif'"
            style="max-width: 135px; width: 100%; margin: auto"
          />
          <ion-card-title
            *ngIf="message1"
            class="fs-4 ion-padding-top font500 marh20 title-text-color"
            [innerHtml]="message1"
          ></ion-card-title>
          <!-- <ion-card-title class="fs-4 ion-padding-top">Travel Club Lounge</ion-card-title> -->
          <ion-card-title
            *ngIf="message2"
            class="fs-4 ion-padding-top font500 marh20 title-text-color"
            >{{ message2 }}</ion-card-title
          >
          <ion-card-title
            *ngIf="message3"
            class="fs-4 ion-padding-top font500 marh20 title-text-color"
            >{{ message3 }}</ion-card-title
          >
          <ion-button
            *ngIf="!bookingReferenceId"
            routerDirections="forward"
            expand="block"
            class="primary-btn fs-4 font500 ion-margin-top"
            (click)="goToHome()"
          >
            {{ "page_status.submit_success.go_to_home_page" | translate }}
          </ion-button>
          <ion-button
            *ngIf="bookingReferenceId"
            (click)="navigate()"
            routerDirections="forward"
            expand="block"
            class="primary-btn fs-4 font500 on-margin-top"
          >
            {{ "page_status.submit_success.view_details" | translate }}
          </ion-button>
        </ion-card>
      </div>
    </ion-row>
  </ion-grid>
</ion-content>
